/**
 * 越南	VN
 * 泰国	TH
 * 菲律宾	PH
 * 马来西亚	MY
 * 新加坡	SG
 * ID	印度尼西亚（Indonesia）
 * IN	印度（India）
 * EG	埃及（Egypt）
 * CN	中国（China） 
 * TR 土耳其
 */
    
(() => {
  const BLOCKED_COUNTRIES = ["ID", "EG", "TR"];
  const TOKEN = window.__IPINFO_TOKEN__ || '0a54e83a614851';
  const STORAGE_KEY = 'ip_country_cache'; 
  const CACHE_TTL_MS = 24 * 60 * 60 * 1000;  // 24h
  const BLOCKED_PAGE_PATH = '/pages/geo-blocked';


  const path = location.pathname;
  if (path.startsWith(BLOCKED_PAGE_PATH)) return;

  function getCachedIso() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const { iso, ts } = JSON.parse(raw);
      if (!iso || !ts || (Date.now() - ts) > CACHE_TTL_MS) return null;
      return iso;
    } catch { return null; }
  }

  function setCachedIso(iso) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ iso, ts: Date.now() }));
    } catch {}
  }

  async function fetchCountryIso() {
    const url = `https://api.ipinfo.io/lite/me?token=${TOKEN}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`IP API ${res.status}`);
    const data = await res.json();
    return (data.country_code || '').toUpperCase();
  }

  (async () => {
    try {
      let iso = getCachedIso();

      if (!iso) {
        iso = await fetchCountryIso();
        if (iso) setCachedIso(iso);
      }

      if (!iso) return;
      if (BLOCKED_COUNTRIES.includes(iso)) {
        if (!path.startsWith(BLOCKED_PAGE_PATH)) {
          location.assign(BLOCKED_PAGE_PATH);
        }
        return;
      }

    } catch (err) {
      console.warn('geo-blocked error:', err);
    }
  })();
})();
